module.exports = __webpack_public_path__ + "img/members.979dd7db.svg";